module.exports = __webpack_public_path__ + "img/rules-footer.36765616.png";